import React from 'react'

import {
  ILayout_Render,
} from '../types/layout'

import {
  BOOKING_EMAIL_REPLACE_TEXT,
} from '../constants/booking'

const BookingDetails: ILayout_Render<any> = ({
  cell,
}) => {
  return (
    <div>
      { BOOKING_EMAIL_REPLACE_TEXT }
    </div>
  )
}

export default BookingDetails 